import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static targets = ['button', 'icon'];

  static values = {
    open: Boolean,
  };

  openValueChanged() {
    this.buttonTarget.setAttribute('aria-expanded', this.openValue);
    this.iconTarget.classList.toggle('is-less', this.openValue);
  }

  toggle() {
    this.openValue = !this.openValue;
  }
}